module.exports = __webpack_public_path__ + "img/calendarDodIcon.04e070dd.svg";